import { Fragment, useState } from 'react';

import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { login } from '../../actions/auth';
import Alert from '../layout/alert';

const Login = ({ login, isAuthenticated }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const { email, password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    login(email, password);
  };

  if (isAuthenticated) {
    return <Navigate to='/'></Navigate>;
  }
  return (
    <Fragment>
      <h1 className='large text-primary'>Belépés</h1>
      <p className='lead'>
        <i className='fas fa-user'></i> Lépj be az oldal használatához
      </p>
      <Alert />
      <form className='form' onSubmit={(e) => onSubmit(e)}>
        <div className='form-group'>
          <input
            type='text'
            placeholder='Email / Felhasználónév'
            name='email'
            value={email}
            onChange={(e) => onChange(e)}
            required
          />
          <small className='form-text'>
            Add meg a regisztráció során megadott e-mail címedet vagy
            felhasználó nevedet
          </small>
        </div>
        <div className='form-group'>
          <input
            type='password'
            placeholder='Jelszó'
            name='password'
            minLength='6'
            value={password}
            onChange={(e) => onChange(e)}
            required
          />
        </div>

        <input type='submit' className='btn btn-primary' value='Belépés' />
      </form>
      <p className='my-1'>
        Nincs még fiókod? <Link to='/register'>Készíts egyet</Link>
      </p>
    </Fragment>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login })(Login);
